import apiClient from "../utils/api-client";

export const getMyAgency = (): Promise<AgencyPublic> =>
  apiClient.get(`/agencies/me`).then(({ data }) => data);
